import axios from '@_system/axios/axios.js'
export default {
	path: '/mcp',
	account(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/account', data, (res) => {
				resolve(res.data)
			},reject)
		})
	}
}
